package pl.decks.personal.site

import kotlin.String

internal object BuildConfig {
  internal const val siteEnv: String = "PROD"

  internal const val phEnv: String = "PROD-main-47f5b19"

  internal const val phKey: String = "phc_oFvTt2PLtTfTLhU9LaUyfPAhsLb88EqgGNZ62NwmXKTY"

  internal const val smtpWebhook: String = ""

  internal val ievpMailUrl: String? = "https://ievp-mail-trigger.piablaze.workers.dev"
}
